import { client } from './client';

// --- Files ---

export const uploadFile = async (serviceUid, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await client.post(`/v1/services/${serviceUid}/files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};

export const getFile = async (uid) => {
    const response = await client.get(`/v1/files/${uid}`, { responseType: 'blob' });
    const contentType = response.headers['content-type'] || '';
    return { blob: response.data, contentType };
};
